<div class="overLayDiv active"></div>
<div id="rightSideBar">
  <div class="rightSidePanel active w-30pc" style="z-index: 99999;">
    <header class="panel-header">
      <div class="viewDemo title-and-video">
        <h2>{{ 'vendor_cat_list_msg7' | translate }}</h2>
      </div>
      <div class="panel-left-btn">
          <button type="button" (click)="fnClosePanel(true);"
              class="btn eod-btn-outline-warning height-38px">
              {{ 'label_close' | translate }}
          </button>
      </div>
    </header>
    
    <div class="clear"></div>
    <div class="row">
      <div class="col-lg-12 no-padding-right-left margin-top-15">
        <div class="block overflow-auto heightCalc-7 scrollbar-visible">
          <div class="row">
            <ul class="bulkList" >
              <li class=" f-14 d-flex justify-content-between flex-row" style="display: flex !important;" 
              *ngFor="let item of list"
                (click)="fnSelect(item)">
                <span class="text-ellipsis">
                  {{item.brandName}}                  
                </span>  
              </li>
            </ul>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>